import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["target", "href", "aria-busy"]
const _hoisted_2 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Download = _resolveComponent("Download")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass([{ 'pointer-events-none text-opacity-50': _ctx.disabled || _ctx.isDownloading }, "bg-primary-700 text-primary-800 bg-opacity-20 hover:bg-opacity-30 transition-colors rounded-lg py-2 px-3 inline-flex space-x-2"]),
    target: _ctx.linkTarget,
    href: _ctx.element.value,
    "aria-busy": _ctx.isDownloading,
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onLinkClicked && _ctx.onLinkClicked(...args)))
  }, [
    _createElementVNode("span", null, _toDisplayString(_ctx.element.label), 1),
    _createElementVNode("span", _hoisted_2, [
      (_ctx.isDownloading)
        ? (_openBlock(), _createBlock(_component_Spinner, {
            key: 0,
            class: "h-4 w-4 my-auto",
            "aria-hidden": "true"
          }))
        : (_ctx.linkBehavior === 'download')
          ? (_openBlock(), _createBlock(_component_Download, {
              key: 1,
              class: _normalizeClass([{ 'opacity-50': _ctx.disabled }, "h-4 w-4 my-auto"]),
              "aria-hidden": "true"
            }, null, 8, ["class"]))
          : (_openBlock(), _createBlock(_component_Icon, {
              key: 2,
              class: _normalizeClass([{ 'opacity-50': _ctx.disabled }, "-rotate-90 transform my-auto"]),
              src: _ctx.IconSource.DropdownPrimary
            }, null, 8, ["class", "src"]))
    ])
  ], 10, _hoisted_1))
}